import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { Space, Form, Button } from 'antd';
import { ApplicationUIContext, Drawer, useDrawerState, Table } from '@yuhuinc/ui-library';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

import AddDeposit from './AddDeposit';

import { getTranslatedString } from 'helpers/i18n';
import { formatMoney, toFriendlyDateString } from 'helpers/Formatter';

const DepositsTable = ({ deposits = [], operations }) => {
  const { isMobile } = useContext(ApplicationUIContext);

  const columns = [
    {
      title: getTranslatedString(
        'landlordPortal.applicationManagement.inviteLeadToApply.deposits.amount'
      ),
      dataIndex: 'amount',
      key: 'amount',
      width: '45%',
      render(value, row) {
        return (
          <Form.Item shouldUpdate>
            {({ getFieldValue }) => {
              const amount = getFieldValue(['deposits', row.name, 'amount']);
              return formatMoney(amount);
            }}
          </Form.Item>
        );
      },
    },
    {
      title: getTranslatedString(
        'landlordPortal.applicationManagement.inviteLeadToApply.deposits.date'
      ),
      dataIndex: 'date',
      key: 'date',
      width: '45%',
      render(value, row) {
        return (
          <Form.Item shouldUpdate>
            {({ getFieldValue }) => {
              const date = getFieldValue(['deposits', row.name, 'date']);
              return toFriendlyDateString(date);
            }}
          </Form.Item>
        );
      },
    },
    {
      key: 'actions',
      width: '15%',
      render(_, row) {
        return (
          <Form.Item shouldUpdate>
            {({ getFieldValue, setFields }) => {
              return (
                <RentalIncentivesTableRowActions
                  deposit={getFieldValue(['deposits', row.name])}
                  onUpdate={(value) => setFields([{ name: ['deposits', row.name], value }])}
                  onDelete={() => operations.remove(row.name)}
                />
              );
            }}
          </Form.Item>
        );
      },
    },
  ];

  return (
    <Table
      dataSource={deposits}
      columns={columns}
      hideActionAndSearch
      disableInternalSearch={true}
      size={isMobile ? 'middle' : 'small'}
      scroll={{
        x: isMobile,
      }}
    />
  );
};

DepositsTable.propTypes = {
  deposits: PropTypes.array,
  operations: PropTypes.any,
};

export default DepositsTable;

const RentalIncentivesTableRowActions = ({ deposit, onUpdate, onDelete }) => {
  const [editDepositDrawerVisible, { open: openEditDepositDrawer, close: closeEditDepositDrawer }] =
    useDrawerState(false);

  function onEditDeposit(values) {
    onUpdate(values);
    closeEditDepositDrawer();
  }

  return (
    <React.Fragment>
      <Space size="middle">
        <Button type="link" icon={<EditOutlined />} onClick={openEditDepositDrawer} />
        <Button type="link" icon={<DeleteOutlined />} onClick={onDelete} />
      </Space>

      <Drawer
        title={getTranslatedString(
          'landlordPortal.applicationManagement.inviteLeadToApply.deposits.editDeposit'
        )}
        visible={editDepositDrawerVisible}
        closable
        destroyOnClose
        onClose={closeEditDepositDrawer}
      >
        <AddDeposit
          initialValues={deposit}
          closeDrawer={closeEditDepositDrawer}
          onAdd={onEditDeposit}
          isEdit
        />
      </Drawer>
    </React.Fragment>
  );
};
